import React from 'react';
import { Typography } from 'antd';
import { VirtualCollection } from 'flare-ui-primitives';
import { getSessionId } from './sessionIdentity.js';

const { Text } = Typography;
const sessionKey = session => (
  getSessionId(session) || `${session.title}-${session.updatedAt || session.updated_at}`
);
const collectionItems = groups => groups.flatMap((group) => [
  ...(group.label ? [{ key: `group:${group.label}`, kind: 'group', label: group.label }] : []),
  ...group.sessions.map((session, index) => ({
    index,
    key: `session:${sessionKey(session)}`,
    kind: 'session',
    session,
  })),
]);

/** Render accepted Session projections inside a caller-owned bounded viewport. */
export default function SessionVirtualCollection({
  continuationError,
  continuationKey,
  gap,
  groups,
  hasMore,
  loadingMore,
  nested,
  onLoadMore,
  renderSession,
  scopeKey,
  scrollElement,
  themeTokens,
}) {
  const items = React.useMemo(() => collectionItems(groups), [groups]);
  return (
    <VirtualCollection
      ariaLabel="会话列表"
      className="flare-session-virtual-collection"
      continuation={{
        error: continuationError ?? null,
        hasMore,
        key: String(continuationKey ?? ''),
        loading: loadingMore,
      }}
      getItemKey={item => item.key}
      items={items}
      layout={{
        columns: 1,
        endThreshold: 96,
        estimateSize: nested ? 42 : 58,
        gap,
        overscan: 4,
      }}
      onLoadMore={() => onLoadMore?.()}
      renderItem={(item) => item.kind === 'group' ? (
        <Text
          style={{
            color: themeTokens.textMuted,
            display: 'block',
            fontSize: 12,
            fontWeight: 500,
            paddingLeft: nested ? 2 : 0,
          }}
          type="secondary"
        >
          {item.label}
        </Text>
      ) : renderSession(item.session, item.index)}
      scopeKey={scopeKey}
      scrollElement={scrollElement}
    />
  );
}
